import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';

import { TranslatePipe } from '../../core/i18n';
import { HapticsService } from '../../services/haptics.service';

@Component({
  selector: 'app-pin-keypad',
  standalone: true,
  imports: [CommonModule, IonIcon, TranslatePipe],
  templateUrl: './pin-keypad.component.html',
  styleUrls: ['./pin-keypad.component.scss'],
})
export class PinKeypadComponent {
  private readonly haptics = inject(HapticsService);

  @Input() disabled = false;
  @Output() digitPressed = new EventEmitter<string>();
  @Output() deletePressed = new EventEmitter<void>();

  readonly keys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['', '0', 'delete'],
  ];

  async onKey(key: string): Promise<void> {
    if (this.disabled || key === '') return;

    await this.haptics.light();

    if (key === 'delete') {
      this.deletePressed.emit();
    } else {
      this.digitPressed.emit(key);
    }
  }
}
